import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';

export interface FilterOption {
  id: string;
  label: string;
  selected: boolean;
}

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent implements OnInit {
  @Input() set options(value: FilterOption[]) {
    this._options = JSON.parse(JSON.stringify(value));
    this.updateInitialState();
  }
  get options(): FilterOption[] {
    return this._options;
  }
  private _options: FilterOption[] = [
    { id: 'direct', label: 'i18n.lists.direct', selected: false },
    {
      id: 'early-cutoff',
      label: 'i18n.lists.earlyCutoff',
      selected: false,
    },
    {
      id: 'discontinued',
      label: 'i18n.lists.discontinuedWhenOut',
      selected: false,
    },
    {
      id: 'exclusive',
      label: 'i18n.lists.exclusiveBrands',
      selected: false,
    },
  ];
  @Output() filterChange = new EventEmitter<FilterOption[]>();
  @Output() clearAll = new EventEmitter<void>();

  private initialOptions: FilterOption[] = [];

  constructor(
    private modalController: ModalController,
    public platformService: PlatformService,
  ) {}

  ngOnInit() {
    this.updateInitialState();
  }

  private updateInitialState() {
    this.initialOptions = JSON.parse(JSON.stringify(this._options));
  }

  hasChanges(): boolean {
    return (
      this._options.some(option => option.selected) ||
      this._options.some(
        (option, index) =>
          option.selected !== this.initialOptions[index].selected,
      )
    );
  }

  toggleOption(option: FilterOption) {
    option.selected = !option.selected;
  }

  onClose() {
    this._options = JSON.parse(JSON.stringify(this.initialOptions));
    this.modalController.dismiss({ action: 'close' });
  }

  onClearAll() {
    this.options.forEach(option => (option.selected = false));
  }

  onSave() {
    this.filterChange.emit(this._options);
    this.updateInitialState();
    this.modalController.dismiss({ action: 'save', options: this._options });
  }
}
